import React, { ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'

type Props = {
  duration: number
  durationText?: ReactElement
}

const ChooseSubscriptionText = ({ duration, durationText }: Props) => (
  <div className="ml-10">
    <div className="flex items-center type-17-demibold lg:static lg:justify-center lg:pb-4 lg:type-17-demibold-caps">
      {duration}&nbsp;
      {duration === 1 ? (
        <FormattedMessage id="Redeem.plans.month" defaultMessage="month" />
      ) : (
        <FormattedMessage id="Redeem.plans.months" defaultMessage="months" />
      )}
    </div>
    <div className="type-small text-TypeSub lg:mb-32">{durationText}</div>
  </div>
)

export default ChooseSubscriptionText
